module.exports = __webpack_public_path__ + "static/media/GT-America-Condensed-Medium.53435ff4.woff";